<template>
  <div>
    <div @click="downloadBase64File(doc?.source?.data, doc?.title)">
      <img
          class="document"
          :src="`${publicPath}/icons/black-file-icon.svg`"
      />
    </div>
  </div>
</template>

<script>
import constants from "@/util/constants";

export default {
  name: 'ChatAttachedPDFDocumentMessage',
  props: {
    doc: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openFile: false,
      publicPath: constants.isDevelopment ? '' : '',
      paper: '<paper>',
      closedPaper: '</paper>',
    }
  },
  methods: {
    downloadBase64File(base64Data, fileName) {
      const downloadLink = document.createElement("a");
      console.log(base64Data, fileName)
      downloadLink.href = 'data:application/pdf;base64,'+base64Data;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  },
};
</script>

<style scoped>
.document {
  height: 40px;
  border-radius: 5px;
}

.document:hover {
  border: solid 2px #00a1fb;
}
</style>
